const SortIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.42583 8.37036V19.3126H7.25405V8.37036L9.20043 11.0511L10.6799 9.97626L6.33996 4L2 9.97626L3.47948 11.0511L5.42583 8.37036Z"
        fill="black"
      />
      <path
        d="M18.1216 15.6298V4.6875H16.2933V15.6299L14.3467 12.949L12.8672 14.0238L17.2075 20.0001L21.5471 14.0232L20.0676 12.9496L18.1216 15.6298Z"
        fill="black"
      />
    </svg>
  );
};

export default SortIcon;
